<template>
  <div class="TabPaneContent" ref="tabPaneContentRef">
    <div v-if="!coursesLoading" class="header">
      <div class="alert-wrap" v-if="bookAlertShow">
        <BookCourseAlert
          :show="bookAlertShow"
          :count="unBookedCourse.length"
          @onClose="doCloseBookAlert"
          @onBook="doBookCourse"
        />
      </div>
      <CourseBar
        :initSelectedIndex="initSelectedCourseIndex"
        :list="courses"
        :isInteractive="isInteractive"
        @changeCourse="changeCourse"
        ref="courseBarRef"
      ></CourseBar>
      <TeacherAndEvaluateBar
        style="margin-top: 16px"
        v-if="currentCourseDetail.course?.course_id"
        :course="currentCourseDetail.course"
      >
        <template
          #book-course
          v-if="currentCourse.biz === 11 && currentCourse.course_classify_id === 3"
        >
          <div
            class="book-course-btn"
            @click="doBookCurrentCourse"
            :class="{ disable: currentCourseDetail.appointment_status === BOOK_STATUS.UNBOOK }"
          >
            {{ bookCourseBtnText }}
          </div>
          <div class="book-course-btn-line" />
        </template>
        <el-input
          v-if="type === 2"
          class="search-input"
          v-model.trim="keyWord"
          size="small"
          placeholder="搜索课程"
          :maxlength="12"
          prefix-icon="el-icon-search"
          clearable
          @change="searchHandler"
          @clear="resetSearch"
        ></el-input>
      </TeacherAndEvaluateBar>
    </div>
    <div v-show="!isSearchScene && currentCourseDetail.course?.course_id" class="list-main">
      <div class="period-list">
        <!-- 章节外显 -->
        <div v-if="currentCourseDetail.is_show_chapter" class="chapter-period-list">
          <el-collapse
            v-if="currentCourseDetail.chapters?.length > 0"
            class="chapter-collapse"
            v-model="expandedChaterId"
            accordion
            @change="handleCollapseChange"
          >
            <!-- :title="chapter.title" -->
            <el-collapse-item
              v-for="chapter in currentCourseDetail.chapters"
              :key="chapter.id"
              :id="`chapter-${chapter.id}`"
              :name="chapter.id"
              v-loading="chapter.chapterLoading"
            >
              <template slot="title">
                <div class="chapter-collapse-title">
                  <span class="show-name">{{ chapter.title }}</span>
                  <span class="show-count">含{{ chapter.periods_num }}节课</span>
                </div>
              </template>
              <!-- <h1 v-for="period in chapter.child" :key="period.id">{{ period.id }}</h1> -->
              <Period
                class="period-item"
                v-for="period in chapter.periods"
                :key="period.period_id"
                :id="`period-${period.period_id}`"
                :period="period"
                :course_id="currentCourse.course_id"
                :course_title="currentCourse.title"
                :course="currentCourseDetail.course"
                :isDatumViewedReport="type === 2"
                :bookStatus="currentCourseDetail.appointment_status"
                @onBookStatus="handleBookStatus"
              />
            </el-collapse-item>
          </el-collapse>
          <EmptyNew v-else title="该课程暂未设置章节"></EmptyNew>
        </div>

        <!-- 章节不外显 -->
        <div v-else class="only-period-list">
          <template v-if="currentCourseDetail.periods?.length > 0">
            <Period
              v-for="period in currentCourseDetail.periods"
              :key="period.period_id"
              :id="`period-${period.period_id}`"
              :period="period"
              :course_id="currentCourse.course_id"
              :course="currentCourseDetail.course"
              :isDatumViewedReport="type === 2"
              :bookStatus="currentCourseDetail.appointment_status"
              @onBookStatus="handleBookStatus"
            />
          </template>
          <EmptyNew v-else title="该课程暂未设置课节"></EmptyNew>
        </div>

        <el-pagination
          v-if="totalPage > 1"
          class="center pager"
          background
          layout="prev, pager, next"
          :total="pageSize * totalPage"
          :page-size="pageSize"
          :current-page="pageNum"
          @current-change="getCourseListByPage"
        ></el-pagination>
      </div>
      <div class="study-exam" v-if="exams.length > 0">
        <p class="title">课程考试</p>
        <CourseExam
          :courseId="currentCourse.course_id"
          v-for="exam in exams"
          :key="exam.id"
          :exam="exam"
        ></CourseExam>
      </div>
    </div>
    <div v-if="isSearchScene" class="search-main">
      <div class="type-bar">
        <el-radio-group
          class="type-radio-group"
          v-model="searchType"
          size="mini"
          @input="searchTypeChange"
        >
          <el-radio-button :label="0">全部</el-radio-button>
          <el-radio-button :label="1">视频</el-radio-button>
          <!-- <el-radio-button :label="2">音频</el-radio-button> -->
          <el-radio-button :label="3">图文</el-radio-button>
        </el-radio-group>
        <div class="total">搜索结果（{{ sarchPage.total }}）</div>
      </div>
      <div class="file-list">
        <SearchFileList
          v-if="searchResultList.length > 0"
          :list="searchResultList"
          :keywords="keyWord"
          :isViewedReport="true"
        />
        <EmptyNew v-else title="暂无搜索记录哦"></EmptyNew>
      </div>

      <el-pagination
        v-if="sarchPage.total > sarchPage.pageSize"
        class="center pager"
        background
        layout="prev, pager, next"
        :total="sarchPage.total"
        :page-size="sarchPage.pageSize"
        :current-page="sarchPage.pageNum"
        @current-change="searchAction"
      ></el-pagination>
    </div>
    <BookCourseDialog
      v-if="bookCourseDialogShow"
      :courses="unBookedCourse"
      :show="bookCourseDialogShow"
      :title="bookCourseDialogTitle"
      :isBatchBook="isBatchBook"
      :selectedIndex="bookCourseIndex"
      @update:show="doCloseBookDialog"
      @bookSuccess="handleBookSuccess"
    />
    <UpdateCourseTimeDialog
      v-if="updateTimeDialogShow"
      :courses="unBookedCourse"
      :currentCourse="currentCourse"
      :show="updateTimeDialogShow"
      :isBatchBook="isBatchBook"
      :bookStatus="bookStatus"
      @update:show="doCloseUpdateCourseDialog"
      @bookSuccess="handleUpdateSuccess"
    />
  </div>
</template>

<script>
import CourseBar from './CourseBar';
import TeacherAndEvaluateBar from './TeacherAndEvaluateBar';
import Period from './Period.vue';
import CourseExam from '@/modules/stu/components/CourseExam.vue';
import EmptyNew from '@/components/EmptyNew';
import SearchFileList from './SearchFileList';
import BookCourseAlert from '@/modules/stu/views/member/components/BookCourseAlert';

import BookCourseDialog from './BookCourseDialog';
import UpdateCourseTimeDialog from './UpdateCourseTimeDialog';
import { BOOK_STATUS } from '../config';

export default {
  customModifiers: {
    'onBook.debounce.300': 'doBookCourse', // 添加延迟时间 300ms
    'click.debounce.300': 'doBookCurrentCourse', // 添加延迟时间 300ms
    'onBookStatus.debounce.300': 'handleBookStatus',
  },
  name: 'TabPaneContent',
  components: {
    CourseBar,
    TeacherAndEvaluateBar,
    Period,
    CourseExam,
    EmptyNew,
    SearchFileList,
    BookCourseAlert,
    BookCourseDialog,
    UpdateCourseTimeDialog,
  },
  props: {
    type: {
      type: Number,
      default: 0, //0 系统课（默认），1 直播课（赠送）， 2 资料课（赠送）
    },
    isInteractive: {
      type: Boolean,
      default: false,
    },
    subject: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      bookCourseIndex: 0,
      BOOK_STATUS,
      coursesLoading: true,
      initSelectedCourseIndex: 0, //上次学习课程序号
      courses: [],
      currentCourse: {},
      currentCourseDetail: {},
      pageNum: 0, //页码从1开始，传0代表找锚点页，接口直接返回锚点页所在page_num和锚点页数据，非0为正常翻页
      pageSize: 10,
      totalPage: 0,
      expandedChaterId: '',
      exams: [],

      /************* 搜索场景 *************/
      isSearchScene: false, //是否是搜索场景
      keyWord: '',
      searchType: 0, //0 全部 1. 视频 2, 音频 3 文档
      searchResultList: [],
      sarchPage: {
        pageNum: 0,
        pageSize: 20,
        total: 0,
      },
      lastSubject: this.subject,
      bookAlertShow: false,
      unBookedCourse: [],
      bookCourseDialogShow: false,
      bookCourseDialogTitle: '预约上课时间',
      isBatchBook: true,
      updateTimeDialogShow: false,
      bookStatus: 0,
    };
  },
  created() {
    this.getInitialData();
    // 获取是否有预约课程alert弹框
    if (this.isInteractive) {
      this.getAllUnBookedCourse();
    }
  },
  watch: {
    isSearchScene: function (newValue, oldValue) {
      if (newValue && !oldValue) {
        this.$webSeeSendTrack({
          event_id: 'resource_search_page_show',
          event_type: 'show',
          data: {
            courseId: this.currentCourse.course_id,
          },
        });
      }
    },
  },
  computed: {
    bookCourseBtnText() {
      if (
        this.currentCourseDetail &&
        this.currentCourseDetail.appointment_status === this.BOOK_STATUS.NOBOOK
      ) {
        return '预约课程';
      }
      return '调换上课时间';
    },
  },
  methods: {
    handleBookStatus() {
      this.doBookCurrentCourse();
    },
    handleBookSuccess() {
      // this.getAllUnBookedCourse();
      // 刷新课程
      this.getInitialData(true);
    },
    handleUpdateSuccess() {
      // 刷新课程
      this.getInitialData(false, this.currentCourse.course_id);
    },
    doCloseBookDialog() {
      this.bookCourseDialogShow = false;
      this.getAllUnBookedCourse();
    },
    doCloseUpdateCourseDialog() {
      this.updateTimeDialogShow = false;
      this.getAllUnBookedCourse();
    },
    async getAllUnBookedCourse() {
      const res = await this.$http.get('/backend-api/app/study/appointment/listUnAppointed');
      this.unBookedCourse = res.courses || [];
      if (res.courses.length > 0) {
        this.bookAlertShow = true;
      } else {
        this.bookAlertShow = false;
      }
    },
    doCloseBookAlert() {
      this.bookAlertShow = false;
    },
    /**
     * 预约课程
     * 1.先确认是否还有待预约的课程
     */
    async doBookCourse() {
      this.isBatchBook = true;
      // 批量预约课程索引位0
      this.bookCourseIndex = 0;
      await this.getAllUnBookedCourse();
      if (this.unBookedCourse.length > 0) {
        // 如果还有待预约的课程，则弹出预约课程弹窗
        this.bookCourseDialogShow = true;
      } else {
        this.$message.success('暂无待预约的课程');
        // 关闭顶部预约课程弹窗
        this.bookAlertShow = false;
      }
    },

    async checkBookStatus() {
      const res = await this.$http.get('/backend-api/app/study/appointment/status', {
        courseId: this.currentCourse.course_id,
      });
      return res.appointment_status;
    },

    async doBookCurrentCourse() {
      if (
        this.currentCourseDetail &&
        this.currentCourseDetail.appointment_status === this.BOOK_STATUS.UNBOOK
      ) {
        return;
      }
      const bookStatus = await this.checkBookStatus();
      if (bookStatus === this.BOOK_STATUS.UNBOOK) {
        this.$message.error('该课程不可预约');
        this.$set(this.currentCourseDetail, 'appointment_status', this.BOOK_STATUS.UNBOOK);
      } else if (bookStatus === this.BOOK_STATUS.NOBOOK) {
        // 预约课程流程
        this.isBatchBook = false;
        await this.getAllUnBookedCourse();
        const courseIndex = this.unBookedCourse.findIndex(
          (item) => item.course_id === this.currentCourse.course_id,
        );
        this.bookCourseIndex = courseIndex > -1 ? courseIndex : 0;
        this.bookCourseDialogShow = true;
        this.$webSeeSendTrack({
          event_id: 'appointment_study_button_click',
          event_type: 'click',
          data: {
            course_id: this.currentCourse.course_id,
          },
        });
      } else {
        // 调换上课时间流程
        this.isBatchBook = false;
        this.bookStatus = bookStatus;
        this.updateTimeDialogShow = true;
        this.$webSeeSendTrack({
          event_id: 'switch_study_button_click',
          event_type: 'click',
          data: {
            course_id: this.currentCourse.course_id,
          },
        });
      }
    },
    async getInitialData(isInitial = false, courseId = 0) {
      const params = {
        course_gift_type: this.type,
        subject: this.subject,
      };
      // biz_type: 默认值为0系统课，11：互动课
      if (this.isInteractive) {
        params.biz_type = 11;
      }
      let data = await this.$http.get('/api/app/myStudy/v2/1', params);

      this.coursesLoading = false;
      this.courses = data.courseList;

      if (data.courseList.length > 0) {
        let anchorCourseIndex = 0;

        //query定向课程
        const targetCourseId = +this.$route.query.id || courseId;
        if (targetCourseId) {
          anchorCourseIndex = data.courseList.findIndex(
            (item) => item.course_id === targetCourseId,
          );
        } else {
          //最近学习的课程
          anchorCourseIndex = data.courseList.findIndex((item) => item.is_last_time_viewed === 1);
        }

        this.initSelectedCourseIndex = anchorCourseIndex > -1 ? anchorCourseIndex : 0;
        if (isInitial) {
          // this.initSelectedCourseIndex = 0;
          this.$refs.courseBarRef.currentIndex = 0;
          // 课程横向列表滑动到最左侧
          this.$refs.courseBarRef.navLeftIndex = 0;
          this.lastSubject = this.subject;
        }
        this.changeCourse(this.initSelectedCourseIndex); //触发最近学习的课程，
      } else {
        if (isInitial) {
          // this.initSelectedCourseIndex = 0;
          this.$refs.courseBarRef.currentIndex = 0;
          // 课程横向列表滑动到最左侧
          this.$refs.courseBarRef.navLeftIndex = 0;
          this.lastSubject = this.subject;
        }
        // 没有课程
        this.currentCourse = {};
        this.currentCourseDetail = {};
      }
    },
    changeCourse(index) {
      this.currentCourse = this.courses[index] || {};
      this.getCourseListByPage(0); //页码从1开始，传0代表找锚点页
      this.resetSearch(); //重置搜索

      //设置TabPaneContent滚动条顶部滚动距离为0
      this.$nextTick(() => {
        this.$refs.tabPaneContentRef.scrollTop = 0;
      });
    },

    //页码从1开始，传0代表找锚点页
    async getCourseListByPage(page) {
      //非0翻页：设置TabPaneContent滚动条顶部滚动距离为0
      this.$nextTick(() => {
        this.$refs.tabPaneContentRef.scrollTop = 0;
      });

      this.pageNum = page;
      this.currentCourseDetail = await this.getCourseDetail(this.pageNum);

      this.pageNum = this.currentCourseDetail.page_num;
      this.totalPage = this.currentCourseDetail.total_page;

      // 章节外显
      if (this.currentCourseDetail.is_show_chapter) {
        //展开锚点章-节-资料
        if (page === 0 && !!this.currentCourseDetail.anchor_id) {
          const anchorChapter = this.currentCourseDetail.chapters.find(
            (item) => item.id === this.currentCourseDetail.anchor_id,
          );

          //展开锚定章
          if (anchorChapter?.id) {
            let anchorElementDomId = ''; //锚定元素的DOM节点id
            anchorElementDomId = `chapter-${anchorChapter.id}`; //锚定章元素的DOM节点id

            this.expandedChaterId = anchorChapter.id;
            await this.handleCollapseChange(this.expandedChaterId);

            //查找锚定课节-锚定资料
            if (anchorChapter.anchor_id) {
              const anchorPeriod = anchorChapter.periods.find(
                (item) => item.period_id === anchorChapter.anchor_id,
              );

              if (anchorPeriod) {
                anchorElementDomId = `period-${anchorPeriod.period_id}`; //锚定课节元素的DOM节点id

                //查找锚定资料
                const anchorDatum = anchorPeriod.datum?.find(
                  (item) => item.is_last_time_viewed === 1,
                );
                if (anchorDatum) {
                  anchorElementDomId = `datum-${anchorDatum.datum_id}`; //锚定课节元素附件文件资料的DOM节点id
                }
              }
            }

            //锚定到指定DOM元素
            // console.log('anchorElementDomId:', anchorElementDomId);
            if (!this.isInteractive) {
              document.getElementById(anchorElementDomId)?.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              });
            }

            return;
          }
        }

        //无锚定章时展开第一章
        this.expandedChaterId = this.currentCourseDetail.chapters[0]?.id;
        this.handleCollapseChange(this.expandedChaterId);
      } else {
        // 非章节外显（隐藏章，课节直接提升显示）
        await this.getHomeworkByPeriodIds(); //拉去作业数据（章节外显不要重复拉作业）

        //展开锚点课节-资料
        if (page === 0 && !!this.currentCourseDetail.anchor_id) {
          //查找锚定课节-锚定资料
          const anchorPeriod = this.currentCourseDetail.periods.find(
            (item) => item.id === this.currentCourseDetail.anchor_id,
          );

          if (anchorPeriod) {
            let anchorElementDomId = ''; //锚定元素的DOM节点id
            anchorElementDomId = `period-${anchorPeriod.period_id}`; //锚定课节元素的DOM节点id

            //查找锚定资料
            const anchorDatum = anchorPeriod.datum?.find((item) => item.is_last_time_viewed === 1);
            if (anchorDatum) {
              anchorElementDomId = `datum-${anchorDatum.datum_id}`; //锚定课节元素附件文件资料的DOM节点id
            }

            //锚定到指定DOM元素
            // console.log('anchorElementDomId:', anchorElementDomId);
            if (!this.isInteractive) {
              document.getElementById(anchorElementDomId)?.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              });
            }
          }

          return;
        }
      }
    },

    //页码从1开始，传0代表找锚点页
    async getCourseDetail(pageNum = 0) {
      await this.getExam();

      const data = await this.$http.get(
        '/api/app/myStudy/course/v2/' + this.currentCourse.course_id,
        {
          pageNum,
          pageSize: this.pageSize,
        },
      );

      if (data.is_show_chapter) {
        data.chapters.forEach((c) => {
          if (!c.periods) {
            c.periods = [];
          }
        });
      } else if (data.periods) {
        data.periods = data.periods.filter((p) => p.parent_id != 0);

        // 课节作业状态初始化
        data.periods.forEach((item) => (item.homework = null));
      }

      this.$webSeeSendTrack({
        event_id: 'my_courses_item_detail_show',
        data: {
          course_id: this.currentCourse.course_id,
          course_title: this.currentCourse.title,
        },
      });
      if (data && data.appointment_status === this.BOOK_STATUS.NOBOOK) {
        this.$webSeeSendTrack({
          event_id: 'appointment_study_button_show',
          data: {
            course_id: data.course && data.course.course_id,
          },
        });
      } else if (data && data.appointment_status !== this.BOOK_STATUS.UNBOOK) {
        this.$webSeeSendTrack({
          event_id: 'switch_study_button_show',
          data: {
            course_id: data.course && data.course.course_id,
          },
        });
      }

      return data;
    },

    async getHomeworkByPeriodIds() {
      const res = await this.$http.get(
        `/api/app/study/period?course_id=${this.currentCourse.course_id}`,
        {},
        {
          showLoading: false,
        },
      );
      if (res) {
        const { homework } = res;
        if (homework) {
          if (this.currentCourseDetail.is_show_chapter) {
            this.currentCourseDetail.chapters.forEach((c) => {
              c.periods.forEach((child) => {
                child.homework = homework[child.period_id];
              });
            });
          } else {
            this.currentCourseDetail.periods.forEach((item) => {
              item.homework = homework[item.period_id];
            });
          }

          this.currentCourseDetail = JSON.parse(JSON.stringify(this.currentCourseDetail)); //解决el-collapse嵌套过深导致的响应式失效
        }
      }
    },

    async handleCollapseChange(chapterId) {
      //展开章
      if (chapterId) {
        const expandedChater = this.currentCourseDetail.chapters.find(
          (item) => item.id === chapterId,
        );

        if (!expandedChater.periods.length) {
          expandedChater.chapterLoading = true;

          const { anchor_id, periods } = await this.$http.get(
            '/api/app/myStudy/course/chapter/periods',
            {
              courseChapterId: chapterId,
              courseId: this.currentCourse.course_id,
            },
            {
              showLoading: false,
            },
          );

          // 调整对应课节
          expandedChater.anchor_id = anchor_id;
          expandedChater.periods = periods.filter((p) => p.parent_id != 0);
          expandedChater.chapterLoading = false;
          await this.getHomeworkByPeriodIds(); //拉去作业数据
          // this.currentCourseDetail = { ...this.currentCourseDetail };
        }
      }
    },

    async getExam() {
      this.exams = await this.$http.get(`/api/app/course/getTest/${this.currentCourse.course_id}`);
    },

    /************* 搜索场景 *************/
    searchHandler() {
      this.$webSeeSendTrack({
        event_id: 'resource_search_search_enter_click',
        event_type: 'click',
        data: {
          courseId: this.currentCourse.course_id,
          searchText: this.keyWord,
        },
      });

      this.searchAction(1);
    },
    searchTypeChange() {
      this.searchResultList = [];
      this.sarchPage = {
        pageNum: 0,
        pageSize: 20,
        total: 0,
      };
      this.searchAction(1);

      this.$webSeeSendTrack({
        event_id: 'resource_search_result_tab_click',
        event_type: 'click',
        data: {
          courseId: this.currentCourse.course_id,
          tab: this.searchType,
        },
      });
    },

    async searchAction(pageNum = 1) {
      this.sarchPage.pageNum = pageNum;

      if (this.keyWord.length > 0) {
        this.isSearchScene = true;

        const data = await this.$http.get('/api/app/myStudy/search', {
          courseId: this.currentCourseDetail.course?.course_id,
          type: this.searchType,
          keyWord: this.keyWord,
          pageNum: pageNum,
          pageSize: this.sarchPage.pageSize,
        });

        this.searchResultList = data.list;
        this.sarchPage.total = data.total;

        this.$webSeeSendTrack({
          event_id: 'resource_search_result_view_show',
          event_type: 'show',
          data: {
            courseId: this.currentCourse.course_id,
            subType: this.type, //0,全部 1，视频 3，资料课
            count: data.total,
          },
        });
      } else {
        this.resetSearch();
      }
    },

    async resetSearch() {
      this.keyWord = '';
      this.searchType = 0;
      this.searchResultList = [];
      this.sarchPage = {
        pageNum: 0,
        pageSize: 20,
        total: 0,
      };
      this.isSearchScene = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.TabPaneContent {
  // padding-top: 16px;
  border-radius: 8px;
  max-height: 800px;
  overflow: scroll;
  background: white;
  padding-bottom: 16px;
  .header {
    .alert-wrap {
      padding: 0 32px 16px;
    }
    position: sticky;
    padding-top: 16px;
    background-color: #fff;
    top: 0; /* 元素在滚动时距离视口顶部的距离 */
    z-index: 10;
    background: #fff;
    &::after {
      content: '';
      display: block;
      margin: 16px 32px 0;
      border-bottom: 1px solid #f5f5f5;
    }
    .search-input {
      background: #f5f5f5;
      border-radius: 4px;
      width: 168px;
      margin-left: 24px;
      ::v-deep {
        .el-input__inner {
          border: none;
          color: #1e1c22;
          font-size: 14px;
          line-height: 20px;
          background: #f5f5f5;
        }
        .el-icon-search {
          color: #8c8b97;
        }
      }
    }
    .book-course-btn {
      font-size: 14px;
      line-height: 20px;
      color: #666;
      cursor: pointer;
      &:hover {
        color: $primary-color;
      }
    }
    .book-course-btn.disable {
      color: #a6a6b1;
      cursor: not-allowed;
    }
    .book-course-btn-line {
      width: 1px;
      height: 14px;
      background: #c0beca;
      border-radius: 1px;
    }
  }
  .list-main {
    padding: 0 32px;
    .chapter-collapse {
      margin-top: 24px;
      border-radius: 8px;
      border: 1px solid #fff;
      background: #fff;
      .chapter-collapse-title {
        margin-right: 8px;
        display: flex;
        flex: 1;
        justify-content: space-between;
        align-items: center;
        .show-name {
          font-size: 16px;
          line-height: 22px;
          font-weight: 500;
          color: #1d1b20;
        }
        .show-count {
          color: #54535c;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }
      }
      ::v-deep {
        .el-collapse-item__header {
          height: auto;
          line-height: 0;
          border-bottom: none;
          background: rgba(250, 250, 250, 0.6);
          &.is-active {
            padding-bottom: 8px;
            border-bottom: 1px solid #f3f3f3;
          }
        }
        .el-collapse-item__wrap {
          border-bottom: none;
          background: rgba(250, 250, 250, 0.6);
        }
        .el-collapse-item {
          padding: 16px;
          border: 1px solid #fff;
          background: rgba(250, 250, 250, 0.6);
          border-radius: 8px;
          margin-bottom: 24px;
          .el-collapse-item__content {
            padding-bottom: 0;
          }
          .period-item {
            margin: 0 12px;
            .period-content {
              padding-left: 0;
              border-bottom: none;
            }
            &:last-child {
              margin-bottom: 0;
              .period-content {
                border-bottom: none;
                padding-bottom: 0;
              }
            }
          }
        }
        .el-collapse-item:last-child {
          margin-bottom: 0;
        }
        .el-collapse-item__arrow {
          margin-right: 0;
          &::before {
            content: '';
            width: 16px;
            height: 16px;
            display: inline-block;
            background: url('~@stu/images/collapse-down.png');
            background-size: cover;
          }
        }
        .el-collapse-item__arrow.is-active {
          -webkit-transform: rotate(-180deg);
          transform: rotate(-180deg);
          transform-origin: center;
        }
      }
    }
    .study-exam {
      border: 1px solid #e6e6e6;
      border-radius: 4px;
      padding: 0 23px 23px 23px;
      margin: 20px 32px 0 32px;
      .title {
        padding: 14px 0;
        color: #999999;
      }
      ::v-deep .exam-item,
      .title {
        border-bottom: 1px dashed #e6e6e6;
      }
    }
  }

  /************* 搜索场景 *************/
  .search-main {
    padding: 16px 32px 0 32px;
    .type-bar {
      display: flex;
      padding: 4px 16px;
      justify-content: space-between;
      align-items: center;
      .type-radio-group {
        display: flex;
        gap: 16px;
        ::v-deep {
          .el-radio-button {
            .el-radio-button__inner {
              padding: 2px 12px;
              color: #46454e;
              text-align: center;
              font-size: 14px;
              line-height: 20px;
              font-weight: 400;
              border-radius: 24px;
              background: #f4f5fa !important;
              box-shadow: none;
              border: none;
            }

            &.is-active {
              .el-radio-button__inner {
                color: #f55;
                background: #ffefec !important;
              }
            }
          }
        }
      }
      .total {
        font-size: 14px;
        line-height: 20px;
        color: #1e1c22;
      }
    }
    .file-list {
      padding: 16px;
    }
  }
}
</style>
